import { API } from "aws-amplify";
import { getServiceRequest } from "src/graphql/queries";
import {
  CreateServiceRequestInput,
  ServiceRequestStatusType,
  ServiceRequestType,
} from "src/API";
import * as APITypes from "~/API";

export const EMPTY_MAINTENANCE: CreateServiceRequestInput = {
  id: "",
  entityID: "",
  entityType: "",
  creatorID: "",
  description: "",
  title: "",
  type: ServiceRequestType.Other,
  isUpgrade: false,
  status: ServiceRequestStatusType.Running,
  emergency: false,
  creatorName: "",
  handlerID: "",
  handlerName: "",
  watcherID: "",
  watcherName: "",
  tenantID: "",
  tenantName: "",
  contractor: "",
  dateCreated: "",
  dateUpdated: "",
  estimatedCost: null,
  finalCost: null,
  userID: "",
  images: null,
};

export const getMaintenanceDetail = async (creatorID: string) => {
  try {
    const response = (await API.graphql({
      query: getServiceRequest,
      variables: {
        id: creatorID,
      },
    })) as { data?: APITypes.GetServiceRequestQuery };

    return {
      success: true,
      data: response.data?.getServiceRequest || EMPTY_MAINTENANCE,
    };
  } catch (error) {
    return {
      success: false,
      data: EMPTY_MAINTENANCE,
      error,
    };
  }
};
